import * as React from "react"

const AccountIcon = (props) => (
  <svg viewBox="0 0 17 22" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{"Account"}</title>
    <g fillRule="nonzero" stroke={props.stroke} fill={props.fill}>
      <path d="M13.258 5.449c0 2.457-2.01 4.448-4.489 4.448S4.28 7.906 4.28 5.45C4.28 2.992 6.29 1 8.77 1c2.478 0 4.488 1.992 4.488 4.449M12.432 12.64h-7.6C2.711 12.64 1 14.339 1 16.439V19a2 2 0 0 0 2 2h11.27a2 2 0 0 0 2-2v-2.555c-.007-2.1-1.72-3.804-3.838-3.804Z" />
    </g>
  </svg>
)

export default AccountIcon
